<template>
  <WfRow
    ref="elementRef"
    :selectable="true"
    :level="2"
    :status="status"
    :disabled="isDefault"
    @check="handleCheck"
    @open="isOpen = $event"
  >
    <template #title>
      <span>{{ mode.name }} <span v-if="isDefault">(default mode)</span></span>
    </template>
  </WfRow>
</template>

<script setup>
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import WfRow from './row/WfRow.vue';
import tippy from 'tippy.js';

const props = defineProps({
  mode: {
    type: Object,
    required: true,
  },
  isDefault: {
    type: Boolean,
    default: false,
  },
});

const store = useStore();

const elementRef = ref(null);
const tooltip = ref(null);
const isOpen = ref(false);

const status = computed(() => {
  return store.getters['variable/getModeStatus'](props.mode.compositeId);
});

const handleCheck = () => {
  if (props.isDefault) return;
  store.dispatch('variable/toggleMode', props.mode.compositeId);
};

onMounted(() => {
  if (props.isDefault) {
    tooltip.value = tippy(elementRef.value.$el, {
      maxWidth: 174,
      theme: 'default-mode-tooltip',
      placement: 'bottom',
      content: 'The default mode is always synced',
      arrow: false,
    });
  }
});

onBeforeUnmount(() => tooltip.value?.destroy());
</script>
